export default "/_next/static/chunks/fonts/AlegreyaSans-Medium-latin-d3257136c954a779b0d09d9c66b8abe9.woff2";